import { registerHandler } from "../handler";
import { trackTask } from "src/utils/monitoring/events/tasks";

declare const window: Window & {
  dataLayer: any;
};

export default function registerHandlers() {
  registerHandler("lead", () => {
    if (window?.dataLayer) {
      const task = trackTask("trackGtmLead");
      try {
        task.start();
        window.dataLayer.push({
          event: "noomLeadEvent",
        });
        task.success();
      } catch (err) {
        task.failed(err);
      }
    }
  });

  registerHandler("purchase", ({ order }) => {
    if (window?.dataLayer) {
      const task = trackTask("trackGtmPurchase");
      try {
        task.start();
        window.dataLayer.push({
          event: "noomPurchaseEvent",
          estimatedValue: order.eltv_13_months.toFixed(3),
          purchaseCurrency: "USD",
          purchaseId: order.subscriptionId,
        });
        task.success();
      } catch (err) {
        task.failed(err);
      }
    }
  });
}
